import React, { useState } from 'react';
import Icon from '../AppIcon';


const QuickActionToolbar = ({ 
  userRole = 'customer',
  onEmergencyCall,
  onQuickBooking,
  onSupportChat,
  className = ''
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const actions = {
    customer: [
      { 
        id: 'emergency',
        icon: 'Phone',
        label: 'Urgence',
        onClick: onEmergencyCall,
        variant: 'destructive'
      },
      { 
        id: 'booking',
        icon: 'Calendar',
        label: 'Réserver',
        onClick: onQuickBooking,
        variant: 'default'
      },
      { 
        id: 'support',
        icon: 'MessageCircle',
        label: 'Support',
        onClick: onSupportChat,
        variant: 'secondary'
      },
    ],
    technician: [
      { 
        id: 'complete',
        icon: 'CheckCircle',
        label: 'Terminer',
        onClick: () => console.log('Complete service'),
        variant: 'success'
      },
      { 
        id: 'call',
        icon: 'Phone',
        label: 'Appeler',
        onClick: () => console.log('Call customer'),
        variant: 'default'
      },
      { 
        id: 'navigate',
        icon: 'Navigation',
        label: 'Naviguer',
        onClick: () => console.log('Navigate'),
        variant: 'secondary'
      },
    ],
    dispatcher: [
      { 
        id: 'assign',
        icon: 'UserPlus',
        label: 'Assigner',
        onClick: () => console.log('Assign technician'),
        variant: 'default'
      },
      { 
        id: 'emergency',
        icon: 'AlertCircle',
        label: 'Urgence',
        onClick: () => console.log('Emergency dispatch'),
        variant: 'destructive'
      },
    ],
    admin: [
      { 
        id: 'reports',
        icon: 'FileText',
        label: 'Rapports',
        onClick: () => console.log('View reports'),
        variant: 'default'
      },
      { 
        id: 'settings',
        icon: 'Settings',
        label: 'Paramètres',
        onClick: () => console.log('Settings'),
        variant: 'secondary'
      },
    ],
    trainer: [
      { 
        id: 'training',
        icon: 'BookOpen',
        label: 'Formation',
        onClick: () => console.log('Training materials'),
        variant: 'default'
      },
      { 
        id: 'schedule',
        icon: 'Calendar',
        label: 'Planning',
        onClick: () => console.log('Training schedule'),
        variant: 'secondary'
      },
    ],
  };

  const currentActions = actions?.[userRole] || actions?.customer;
  const primaryAction = currentActions?.[0];
  const secondaryActions = currentActions?.slice(1);

  return (
    <div className={`quick-action-toolbar ${className}`}>
      {isExpanded && secondaryActions?.map((action) => (
        <button
          key={action?.id}
          onClick={action?.onClick}
          className={`quick-action-button bg-${action?.variant === 'destructive' ? 'error' : action?.variant === 'success' ? 'success' : action?.variant === 'secondary' ? 'secondary' : 'primary'}`}
          title={action?.label}
          aria-label={action?.label}
        >
          <Icon name={action?.icon} size={24} color="#FFFFFF" />
        </button>
      ))}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="quick-action-button"
        title={isExpanded ? 'Fermer' : primaryAction?.label}
        aria-label={isExpanded ? 'Fermer le menu' : primaryAction?.label}
      >
        <Icon 
          name={isExpanded ? 'X' : primaryAction?.icon} 
          size={24} 
          color="#FFFFFF" 
        />
      </button>
    </div>
  );
};

export default QuickActionToolbar;